import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SchoolGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.schoolLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['login'], { queryParams: { tab: 'school' } });
      return false;
    }
  }
}
